import { render, staticRenderFns } from "./add-interview-review-model.vue?vue&type=template&id=0f101d4a"
import script from "./add-interview-review-model.vue?vue&type=script&lang=js"
export * from "./add-interview-review-model.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports